import {
  createSlice,
  type PayloadAction,
} from '@reduxjs/toolkit';

export type WelcomeOfferState = {
  timerId: Maybe<NodeJS.Timeout>;
  modalOpen: boolean;
};

const initialState: WelcomeOfferState = {
  timerId: null,
  modalOpen: false,
};

export const welcomeOfferSlice = createSlice({
  name: 'welcome-offer',
  initialState,
  reducers: {
    setOpenWelcomeOfferModal: (state: WelcomeOfferState, action: PayloadAction<boolean>) => {
      state.modalOpen = action.payload;
    },
    setWelcomeOfferTimerId: (state: WelcomeOfferState, action: PayloadAction<Nullable<NodeJS.Timeout>>) => {
      state.timerId = action.payload
    },
  },
});

export const {
  setWelcomeOfferTimerId,
  setOpenWelcomeOfferModal,
} = welcomeOfferSlice.actions;
export const welcomeOfferReducer = welcomeOfferSlice.reducer; 